module.exports = __webpack_public_path__ + "img/pethouse44.c5496fc5.jpg";